<template>
  <div class="swiper mySwiper pa-4" style="max-width: 100%">
    <div class="swiper-wrapper">
      <slot name="default"/>
    </div>
    <div class="swiper-button-prev">
      <v-btn fab depressed small>
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <div class="swiper-button-next">
      <v-btn fab depressed small>
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import {FreeMode, Navigation, Swiper} from 'swiper';
import "swiper/swiper-bundle.min.css";

let swiper = null

export default {
  name: "swiperSlider",

  mounted() {
    swiper = new Swiper(`.swiper`, {
      // Optional parameters
      // @see https://swiperjs.com/swiper-api#parameters
      // freeMode: {
      //   enabled: true,
      //   sticky: true,
      // },
      spaceBetween: 20,
      breakpoints: {
        1920: {
          slidesPerView: 3.3,
          spaceBetween: 20
        },
        1264: {
          slidesPerView: 3.2,
          spaceBetween: 20
        },
        960: {
          slidesPerView: 2.4,
          spaceBetween: 20
        },
        600: {
          slidesPerView: 1.4,
        },
        320: {
          slidesPerView: 1.3,
        }
      },
      // remove unused modules if needed
      modules: [Navigation, FreeMode],
      // Navigation arrows if needed
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
}
</script>

<style scoped>
.swiper-button-prev::after,
.swiper-button-next::after {
  content: none !important;
}
</style>